/**
 * @module text
 */

export { default as quote } from './quote';
export { default as unquote } from './unquote';
export { default as unwrap } from './unwrap';
export { default as isQuoted } from './isQuoted';
export { default as isWrappedWith } from './isWrappedWith';
export { default as bin2Hex } from './bin2Hex';
export { default as base64Encode } from './base64Encode';
export { default as base64Decode } from './base64Decode';
export { default as compile } from './compile';
export { default as template, esTemplate } from './template';
export { default as replaceAll } from './replaceAll';
export { default as dropIfEndsWith } from './dropIfEndsWith';
export { default as dropIfStartsWith } from './dropIfStartsWith';
export { default as ensureEndsWith } from './ensureEndsWith';
export { default as ensureStartsWith } from './ensureStartsWith';
export { default as csvLineParse } from './csvLineParse';
export { default as baseName } from './baseName';
export { default as changeExtName } from './changeExtName';
export { default as splitBaseAndExt } from './splitBaseAndExt';
export * from './split';
export { default as suffixForDuplicate } from './suffixForDuplicate';
export { default as countOfChar } from './countOfChar';
export { default as deleteLines } from './deleteLines';
export { default as grepLines } from './grepLines';
export { default as trimLines } from './trimLines';
export * from './trim';
export * from './padding';
export * from './n2b64';
